// Wrapper chrome for a device control screen.
//
// Two modes:
//  - Standalone (default): full-height page with an AppBar + hardware back — used
//    by the /device/:uniqueNumber route on mobile / small screens.
//  - Embedded: no AppBar, no min-height — used when a control screen is rendered
//    inside the desktop shell's right-side device panel (the panel supplies its
//    own title + close). Turn it on by wrapping the tree in
//    `<EmbeddedContext.Provider value={true}>`.

import React, { createContext, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, AppBar, Toolbar, IconButton, Typography } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

export const EmbeddedContext = createContext(false);

export default function DeviceShell({ title, children, actions }) {
  const embedded = useContext(EmbeddedContext);
  const navigate = useNavigate();

  if (embedded) {
    return (
      <Box>
        {actions && (
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', px: 2, pt: 1 }}>
            {actions}
          </Box>
        )}
        <Box sx={{ p: 2 }}>{children}</Box>
      </Box>
    );
  }

  return (
    <Box sx={{ minHeight: '100%', bgcolor: 'background.default' }}>
      <AppBar position="static" elevation={2}>
        <Toolbar>
          <IconButton edge="start" color="inherit" onClick={() => navigate(-1)}>
            <ArrowBackIcon />
          </IconButton>
          <Typography variant="h6" sx={{ flex: 1, textAlign: 'center' }} noWrap>{title}</Typography>
          <Box sx={{ minWidth: 40, display: 'flex', justifyContent: 'flex-end' }}>{actions}</Box>
        </Toolbar>
      </AppBar>
      <Box sx={{ p: 2 }}>{children}</Box>
    </Box>
  );
}
